import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { errorNormalizer } from '../../../shared/Helpers/functions';
import { RED } from '../../../shared/Helpers/colors';
import { CustomAlert, CustomButton } from '../../../shared/uiComponents';
import { TrashEmpty } from '../../../shared/Assets/sessionDetailsSVGs';
import { ButtonWrapper } from '../../../components/StyledComponents';

import { DispatchProperties } from '../../../redux/store';
import { deleteClient, getClients } from '../../../redux/State/clientSlice/clientSlice';

const Content = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const { clientId } = useParams();

	const fetchClients = () => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const searchString = params.get('search') || '';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const status = params.get('status');
		const caseCoordinatorId = params.get('caseCoordinatorId') || '';

		dispatch(
			getClients({
				page,
				pageSize,
				direction,
				orderBy,
				searchString,
				status,
				caseCoordinatorId,
			}),
		);
		navigate('/clients');
	};

	const deleteClientHandler = () => {
		if (!clientId) return;
		dispatch(deleteClient(clientId))
			.then(unwrapResult)
			.then(() => {
				toast(`Deleted`);
				fetchClients();
			})
			.catch(errorNormalizer);
	};

	return (
		<ButtonWrapper>
			<CustomButton title="Delete" onClick={deleteClientHandler} />
			<CustomButton title="Cancel" onClick={onClose} buttonType="secondaryGray" />
		</ButtonWrapper>
	);
};

const DeleteClient = () => {
	const [areYouSure, setAreYouSure] = useState<boolean>(false);

	return (
		<>
			<CustomButton
				iconOnly={<TrashEmpty color={RED.BASE} />}
				onClick={() => setAreYouSure(true)}
				buttonType="secondary"
				style={{ backgroundColor: RED.QUATERNARY, borderColor: RED.BASE }}
				sizeType="md"
			/>
			<CustomAlert open={areYouSure} onClose={() => setAreYouSure(false)} title="Are you sure?" Content={Content} />
		</>
	);
};

export default DeleteClient;
